/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormProfileSnapshotRefreshDto } from '../../models/form-profile-snapshot-refresh-dto';

export interface RefreshFormProfileSnapshot$Params {
  formId: string;
}

export function refreshFormProfileSnapshot(
  http: HttpClient,
  rootUrl: string,
  params: RefreshFormProfileSnapshot$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormProfileSnapshotRefreshDto>> {
  const rb = new RequestBuilder(rootUrl, refreshFormProfileSnapshot.PATH, 'get');
  if (params) {
    rb.path('formId', params.formId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormProfileSnapshotRefreshDto>;
    })
  );
}

refreshFormProfileSnapshot.PATH = '/forms/{formId}/profile-snapshot/refresh';
